<template>
    <div class="role-filter">
        <!-- Selected Roles Display -->
        <div v-if="localSelectedRoleIds && localSelectedRoleIds.length > 0" class="selected-roles-list">
            <div class="selected-items">
                <div
                    v-for="roleId in localSelectedRoleIds"
                    :key="`selected-${roleId}`"
                    class="unified-filter-row"
                >
                    <span class="filter-content-text">{{ getRoleName(roleId) }}</span>
                    <div style="margin-left: auto;">
                        <button
                            class="remove-filter-button-fixed"
                            :aria-label="`Remove ${getRoleName(roleId)} filter`"
                            @click.stop="removeRoleFromFilter(roleId, filter)"
                        >
                            <e-icon icon="times" size="is-small" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Search input for narrowing the available roles list -->
        <div v-if="availableRoles.length > 0" class="unified-filter-row role-search-row" @click.stop>
            <e-input
                v-model="roleSearch"
                icon="search"
                clearable
                expanded
                size="is-small"
                placeholder="Search roles..."
                aria-label="Search roles"
                class="tw:w-full"
            />
        </div>

        <!-- Available Roles List -->
        <div :key="`available-roles-${(filter.value || []).join('-')}`" class="available-roles-list">
            <div class="available-items available-items-container">
                <div
                    v-if="availableRoles.length === 0"
                    class="unified-filter-row"
                >
                    <span class="filter-content-text">All roles are selected</span>
                </div>
                <div
                    v-else-if="filteredRoles.length === 0"
                    class="unified-filter-row"
                >
                    <span class="filter-content-text">No roles match your search</span>
                </div>
                <div
                    v-for="(role, index) in filteredRoles"
                    :key="`available-role-${role.id}-${index}`"
                    class="unified-filter-row clickable-item"
                    :class="{ 'has-border-bottom': index < filteredRoles.length - 1 }"
                    @click.stop="addRoleToFilter(role.id, filter)"
                >
                    <e-checkbox
                        :value="false"
                        size="is-small"
                        @click.stop="addRoleToFilter(role.id, filter)"
                    />
                    <span class="filter-content-text">
                        {{ role.name }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoleFilterItem',

    props: {
        filter: {
            type: Object,
            required: true,
        },
        availableRoles: {
            type: Array,
            required: true,
        },
        localSelectedRoleIds: {
            type: Array,
            required: true,
        },
        addRoleToFilter: {
            type: Function,
            required: true,
        },
        removeRoleFromFilter: {
            type: Function,
            required: true,
        },
        getRoleName: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            roleSearch: '',
        };
    },

    computed: {
        filteredRoles() {
            const term = this.roleSearch.trim().toLowerCase();

            if (!term) {
                return this.availableRoles;
            }

            return this.availableRoles.filter(role =>
                String(role?.name || '')
                    .toLowerCase()
                    .includes(term)
            );
        },
    },
};
</script>

<style scoped>
/* Role filter specific styles */
.role-filter {
    width: 100%;
}

.selected-items {
    margin-bottom: 8px;
}

.role-search-row {
    padding-bottom: 8px;
}

.available-items-container {
    background: var(--scheme-main);
    max-height: 265px;
    overflow-y: auto;
}

.has-border-bottom {
    border-bottom: 1px solid var(--border);
}

.clickable-item {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.clickable-item:hover {
    background-color: var(--scheme-main-bis) !important;
}


.unified-filter-row {
    display: flex;
    padding: 7.2px 14.4px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.filter-content-text {
    color: var(--text);
    font-family: Stolzl;
    font-size: 13.68px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.remove-filter-button-fixed {
    border: none !important;
    background: transparent !important;
    color: #666 !important;
    padding: 2px !important;
    height: auto !important;
    min-height: auto !important;
    line-height: 1 !important;
    cursor: pointer;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}
</style>
